import Page from "components/Page";
import { CatalogueListProps } from "./CatalogueList.types";
import { lazyWithRetry } from "helpers/lazyWithRetry";

const CatalogueList = lazyWithRetry(() => import("./CatalogueList"));

export default (props: CatalogueListProps) => (
  <Page>
    <CatalogueList {...props} />
  </Page>
);
